'use client';

import Image from 'next/image';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subTitle?: string;
  description: string;
}

export function AuthLayout({ children, title, subTitle, description }: AuthLayoutProps) {
  return (
    <div className="blue-theme flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 via-blue-100 to-blue-50 px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="space-y-1">
          <div className="mb-3 flex justify-center">
            <Image
              src="/logo-transparent.png"
              alt="tes-navi"
              width={1032}
              height={243}
              priority
              className="h-9 w-auto"
            />
          </div>
          <h1 className="text-center text-2xl font-bold text-gray-900">{title}</h1>
          {subTitle && <p className="text-center text-gray-500">{subTitle}</p>}
          {description && <p className="text-center text-gray-500">{description}</p>}
        </div>
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
}
